import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  baseUrl: string;

  noCacheHeaders: HttpHeaders = new HttpHeaders({
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  });

  constructor(private http: HttpClient, private environmentLoaderService: EnvironmentLoaderService) {
    this.baseUrl = this.environmentLoaderService.config.egisServiceBaseUrl;
  }

  getPortalVersion(): Observable<any> {
    return this.http.get('assets/version.txt', {
      headers: this.noCacheHeaders,
      responseType: 'text',
    });
  }

  getServiceVersion(): Observable<any> {
    return this.http.get(this.baseUrl + '/version', {
      responseType: 'text',
    });
  }
}
